export interface PopularVideo {
  '@id': string;
  '@path': string;
  articleTitle: string;
  introText: string;
}
